// extracted by mini-css-extract-plugin
export var cardHeader = "_ij-0";
export var reorderHandle = "_ij-3";
export var titleArea = "_ij-1";
export var titleAreaWithHandle = "_ij-2";